import { render } from "./CollectionsPage.vue?vue&type=template&id=3bb43c74"
import script from "./CollectionsPage.vue?vue&type=script&lang=js"
export * from "./CollectionsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__